module.exports = __webpack_public_path__ + "static/media/sun-big-cloud.77ac87ee.png";